import { Component, OnInit } from '@angular/core';
import { EmbedVideoService } from 'ngx-embed-video';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

///This is the Resources page

declare var require: any

export interface FacilityRegistrationElement {
  SubscriptionDateTo: Date;
  SubscriptionDateFrom: Date;
  FacilityLicenseId: string;
  FacilityName: string;
  FacilityPostOffice: string;
  Status: number;
}

@Component({
  selector: 'app-portal-download',
  templateUrl: './portal-download.component.html',
  styleUrls: ['./portal-download.component.css']
})
export class PortalDownloadComponent implements OnInit {
  name = 'Angular 6';

  yt_iframe_html: any;
  
  youtubeUrl = "https://youtu.be/v8_S1kURueE";

  constructor(
    private embedService: EmbedVideoService
  ) {
    this.yt_iframe_html = this.embedService.embed(this.youtubeUrl);
  }

  ngOnInit(){}
}